import * as React from "react";
import { cn } from "../../../lib/utils";

function LoadingBlock({ message = "در حال بارگذاری...", className }) {
  return (
    <div
      className={cn(
        "py-12 text-center text-lg text-[#718096] max-md:text-base",
        className,
      )}
    >
      {message}
    </div>
  );
}

export { LoadingBlock };
